import React, { Component } from 'react';
import './ResultAnalysisBox.css'
import ResultAnalysisMenuBar from './ResultAnalysisMenuBar';
import RAPriceWidget from './RAPriceWidget';

export default class ResultAnalysisBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            section: "price",
            subsection: "0"
        };
    }
    handleRecPerPageChange = (e) => {
        this.props.onRecPerPageChange(e.target.value);
    }
    handlePageChange = (pageno) => {
        this.props.onPageChange(pageno);
    }
    handleMenuChange = (section) => {
        this.setState({ section, subsection: section==="corpinfo"?"1":"0" });
    }
    handleSubSectionChange = (subsection) => {
        this.setState({ subsection });
    }
    render() {
        const { section, subsection } = this.state;
        return (
            <div className="ResultAnalysisBox">
                <div className="resultinfo">該当銘柄 <span className="count">{this.props.data.count}</span> 件  {this.props.pageno}ページ目（{this.props.data.count===0?0:((this.props.pageno-1)*this.props.recperpage+1)}～{(this.props.pageno*this.props.recperpage<this.props.data.count)?this.props.pageno*this.props.recperpage:this.props.data.count}件表示）
                { this.state.section==="list" &&
                <div className="nppbox"><select onChange={this.handleRecPerPageChange} value={this.props.recperpage}><option>20</option><option>50</option></select>件表示</div>}</div>
                <ResultAnalysisMenuBar section={section} onMenuChange={this.handleMenuChange} />
                <RAPriceWidget token={this.props.token} appId={this.props.appId} section={section} subsection={subsection} data={this.props.data} pageno={this.props.pageno} recperpage={this.props.recperpage} onPageChange={this.handlePageChange} onSubSectionChange={this.handleSubSectionChange} handleCompInfoPopupChange={this.props.handleCompInfoPopupChange}/>
            </div>
        )
    };
}